import React, { useState, useContext } from 'react';
import { Share2, UserPlus } from 'lucide-react';
import IsAuth from '../../../createContext/is-Auth/IsAuthContext';
import DefaultCommunityImage from '../../images/default-community.png';
import ProfilePassionsGrid from '../../Profile/Components/ProfilePassionsGrid';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';

const CommunityDetailsSection = ({ 
  activeCommunity, 
  setShowCommunityDetails,
  showCommunityDetails
}) => {
  const { user,token } = useContext(IsAuth);
  const [isAddPlayerModalOpen, setIsAddPlayerModalOpen] = useState(false);
  const handleInvite = () => {
  
    if (navigator.share) {
      navigator.share({
        title: `Join ${activeCommunity.name} Community`,
        text: `Check out this awesome community on our platform!`,
        url: `${process.env.REACT_APP_FRONTEND_URL}/messages/${activeCommunity._id}`
      }).catch((error) => console.log('Error sharing', error));
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard?.writeText(`${process.env.REACT_APP_FRONTEND_URL}/messages/${activeCommunity._id}`)
        .then(() => alert('Community link copied to clipboard!'));
    }
  };

  const filteredFollowingUsers = user?.following?.filter(
    followedUser => !activeCommunity.members.some(
      member => member.id === followedUser._id
    )
  ) || [];


  const handleAddPlayer =  async(playerToAdd) => {
    try {
      toast.success(`Invitation Email sent to ${playerToAdd.userName}`);
      setIsAddPlayerModalOpen(false);
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/invitePlayerToCommunity`, {
        communityId: activeCommunity._id,
        userId: playerToAdd._id
      },{headers:{token}});
    } catch (error) {
      // Handle error
      toast.error(error.response?.data?.message || 'Failed to send invitation');
    }
  };

  return (
    <>
    <div className="community-details-section overflow-auto scrollbar-hide">
      <div className="flex justify-between items-center mb-4">
        <div 
          className="bg-gray-200 p-1 rounded-lg cursor-pointer" 
          onClick={() => setShowCommunityDetails(false)}
        > 
          <span className="font-bold">X</span> Close
        </div>
        <div className="flex space-x-2">
          <button 
            onClick={handleInvite}
            className="flex items-center bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 transition"
          >
            <Share2 size={16} className="mr-2" /> Invite
          </button>
          <button 
            onClick={() => setIsAddPlayerModalOpen(true)}
            className="flex items-center bg-green-500 text-white px-3 py-1 rounded-lg hover:bg-green-600 transition"
          >
            <UserPlus size={16} className="mr-2" /> Add Player
          </button>
        </div>
      </div>

      {/* Existing Community Details Content */}
      <h2 className="font-medium">Description:</h2>
      <div className="community-description">
        <p>{activeCommunity.description}</p>
        <div className="community-meta">
          <span>Industry: {activeCommunity.industry}</span>
          <span>Location: {activeCommunity.location}</span>
        </div>
      </div>

      {activeCommunity.passions && (
        <ProfilePassionsGrid passions={activeCommunity.passions} showPassions={true}/>
      )}

      {/* Add Player Modal */}
      {isAddPlayerModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Add Players</h3>
              <button 
                onClick={() => setIsAddPlayerModalOpen(false)}
                className="text-gray-600 hover:text-gray-900"
              >
                ✕
              </button>
            </div>
            {filteredFollowingUsers.length > 0 ? (
              filteredFollowingUsers.map(user => (
                <div 
                  key={user._id} 
                  className="flex items-center justify-between border-b py-2"
                >
                  <div className="flex items-center">
                    <img 
                      src={user.avatar || DefaultCommunityImage} 
                      alt={user.userName} 
                      className="w-10 h-10 rounded-full mr-3"
                    />
                    <div>
                      <p className="font-medium">{user.userName}</p>
                      <p className="text-sm text-gray-500">{user.name}</p>
                    </div>
                  </div>
                  <button 
                    onClick={() => handleAddPlayer(user)}
                    className="bg-blue-500 text-white px-3 py-1 rounded-lg hover:bg-blue-600 text-sm"
                  >
                    Invite
                  </button>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500">
                No followers to add to the community
              </p>
            )}
          </div>
        </div>
      )}

      {/* Existing Admins and Members Sections */}
      <div className="community-members-section">
        <h4>Admins ({activeCommunity.admins ? activeCommunity.admins.length : 0})</h4>
        <div className="members-list">
          {activeCommunity.admins && activeCommunity.admins.map((admin) => (
            <div key={admin.id || admin._id} className="member-item">
              <img
                src={admin.avatar || DefaultCommunityImage}
                alt={admin.name}
                className="member-avatar"
              />
              <span>{admin.name}</span>
            </div>
          ))}
        </div>

        <h4>Members ({activeCommunity.members ? activeCommunity.members.length : 0})</h4>
        <div className="members-list">
          {activeCommunity.members && activeCommunity.members.map((member) => (
            <div key={member.id || member._id} className="member-item">
              <img
                src={member.avatar || DefaultCommunityImage}
                alt={member.name}
                className="member-avatar"
              />
              <span>{member.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  <ToastContainer />
  </>
  );
};

export default CommunityDetailsSection;